import { Reveal } from "./Reveal";
import { IMAGES } from "./data";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="overline mb-8">The 9jaclicks Ethos</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              We don't just move you. We help you <span className="italic text-gold">belong</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl text-lg font-light leading-relaxed text-foreground/70">
              Based in Saskatoon, Canada and moving with the world, 9jaclicks Limited is a premium settlement house.
              Relocating across borders is complex — immigration, housing, schooling, banking and the hundred quiet details
              in between. We manage all of it, end to end, so you and your family settle seamlessly into your new life.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-6 max-w-xl text-lg font-light leading-relaxed text-foreground/70">
              Beyond arrival, our investment, travel, bespoke experiences and lifestyle concierge keep your world moving with the
              same standard — perfection, delivered discreetly. This is relocation, elevated.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden">
              <img
                src={IMAGES.about}
                alt="Elegant event setting"
                className="w-full h-[520px] object-cover transition-transform duration-[1.2s] ease-out hover:scale-105"
              />
              <div className="absolute inset-0 border border-white/10" />
              <div className="absolute -bottom-px -left-px h-16 w-16 border-b-2 border-l-2 border-gold" />
              <div className="absolute -top-px -right-px h-16 w-16 border-t-2 border-r-2 border-gold" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
